import { formatDate } from '@shared/utils/base/index.js'

/**
 * @param {Number, NumberString, Date} time
 * @param {string} format
 */
const dateFilter = (time, format) => {
  let date = time

  if (Object.prototype.toString.call(time) !== '[object Date]') {
    date = new Date(+time)
  }

  return formatDate(date, format)
}

const fileUnit = (val, type, decimal = 2) => {
  let newVal = val
  if (type === 'kb') {
    newVal = val / 1024
  } else if (type === 'mb') {
    newVal = val / 1024 / 1024
  }

  return newVal.toFixed(decimal)
}

export { dateFilter, fileUnit }
